import ConnectImg from "../../../assets/images/connect.png";
export const connectData = {
  title: "Your Next Developer is Just a Click Away!",
  describe:
    "Harness the power of cutting-edge technology and robust frameworks to elevate your projects. Connect with me for impactful solutions.",
  letsConnectText: "LETS CONNECT",
  img: ConnectImg,
};
